import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ValidationService {

	constructor() { }

	public email_pattern = '^[a-zA-Z0-9-]+(?:[+.][a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$'
	public sa_cell_number_pattern = '^(0|\\+?27)[1-9][0-9]{8}$'

	words(input: string) {
		return /^.*[a-zA-Z].*$/.test(input)
	}
	number(input: string) {
		return /^[0-9]+$/.test(input)
	}
	email(input: string) {
		return new RegExp(this.email_pattern).test(input)
	}
	sa_cell_number(input: string) {
		return new RegExp(this.sa_cell_number_pattern).test(input)
	}

}
